const BLUR_LAYERS = [0, 1, 2, 3] as const;

const ScrollEdge = ({ side }: { side: "top" | "bottom" }) => (
  <div
    aria-hidden
    data-scroll-edge={side}
    className={`scroll-edge scroll-edge-${side}`}
  >
    {BLUR_LAYERS.map((layer) => (
      <span key={layer} className="scroll-edge-blur" />
    ))}
    <span className="scroll-edge-tint" />
    {side === "top" ? <span className="scroll-edge-status" /> : null}
  </div>
);

/**
 * iOS scroll edge effect: content passing under the status bar and the top
 * row, or under the tab bar, blurs and fades out progressively so the
 * floating controls stay readable. Purely decorative and never hit-testable;
 * stacked above the page but below every floating control and sheet (see
 * .scroll-edge in index.css).
 */
export const MobileScrollEdges = () => (
  <>
    <ScrollEdge side="top" />
    <ScrollEdge side="bottom" />
  </>
);
